import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.094 9.1H12.1a.996.996 0 0 1-.998-.998V4.106a.997.997 0 0 1 1.705-.708.998.998 0 0 1 .293.707V5.69l3.335-3.334a.999.999 0 0 1 1.413 1.411l-3.336 3.334h1.584a.999.999 0 0 1 0 1.999zM7.342 4.306l.534 2.67a1.495 1.495 0 0 1-.802 1.634l-.975.488c0 2 3 5 5 5l.488-.975a1.5 1.5 0 0 1 1.636-.8l2.67.534a1.5 1.5 0 0 1 1.206 1.471v3.235c0 .859-.725 1.572-1.584 1.535C6.6 18.71 1.561 14.847 1.101 4.686 1.062 3.827 1.778 3.1 2.638 3.1h3.233a1.5 1.5 0 0 1 1.471 1.206z"
});

var SvgPhoneInMajor = function SvgPhoneInMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgPhoneInMajor as S };
